import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { FormElementInterface } from 'src/shared/types/entities/form-interface'

export const SWITCH_ENTITY_INNER_ITEM_ACTIVE_INDEX =
  'SWITCH_ENTITY_INNER_ITEM_ACTIVE_INDEX'
export const SET_EDITING_ENTITY = 'SET_EDITING_ENTITY'
export const SET_SETTINGS_EDITING = 'SET_SETTINGS_EDITING'
export const SET_USER_COLORS = 'SET_USER_COLORS'
export const NEED_SCROLL = 'NEED_SCROLL'
export const TOGGLE_INSTANT_UPLOAD = 'TOGGLE_INSTANT_UPLOAD'
export const TOGGLE_PAYPAL_SETTINGS = 'TOGGLE_PAYPAL_SETTINGS'
export const SET_SHOWN_SEARCH_RESULTS = 'SET_SHOWN_SEARCH_RESULTS'

interface BaseAction {
  type: string
  [key: string]: unknown
}

export interface NeedScrollAction extends BaseAction {
  type: typeof NEED_SCROLL
  payload: boolean
}

export interface ToggleInstantUpload extends BaseAction {
  type: typeof TOGGLE_INSTANT_UPLOAD
  payload: boolean
}

export interface TogglePayPalSettings extends BaseAction {
  type: typeof TOGGLE_PAYPAL_SETTINGS
  payload: boolean
}

export interface SwitchEntityInnerItemActiveIndex extends BaseAction {
  type: typeof SWITCH_ENTITY_INNER_ITEM_ACTIVE_INDEX
  payload: {
    entityId: string
    entityInnerItemActiveIndex: number
  }
}

export interface SetEditingEntity extends BaseAction {
  type: typeof SET_EDITING_ENTITY
  payload: string
}

export interface SetSettingsEditing extends BaseAction {
  type: typeof SET_SETTINGS_EDITING
  payload: {
    id: string
    needOverlay?: boolean
  } & (
    | {
        type?: Exclude<EntityTypeEnum, EntityTypeEnum.Form>
        elementId?: never
      }
    | {
        type: EntityTypeEnum.Form
        elementId?: FormElementInterface['id'] | undefined
      }
  )
}

export interface SetUserColors extends BaseAction {
  type: typeof SET_USER_COLORS
  payload: string[]
}

export interface SetShownSearchResults extends BaseAction {
  type: typeof SET_SHOWN_SEARCH_RESULTS
  payload: string[]
}
